import * as api from '@/network/api'
import Vue from 'vue'
import * as Analytics from '@/helpers/analytics.js'
import * as Utils from '@/helpers/utils.js'
import i18n from '@/i18n'
export function provideURL(url) {
    return url
}

export function downloadFile(src, customName) {
    const fileName = customName || Utils.getAttachmentName(src)
    const url = `${Utils.convertImageUrl(src)}&attachment=true`
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    link.setAttribute('type', 'application/octet-stream')
    document.body.appendChild(link)
    link.click()
}
export function repeatRequest(
    fn,
    data,
    url,
    resolve,
    reject,
    error,
    leftAttempts
) {
    if (leftAttempts == 0) {
        reject(error)
    } else {
        --leftAttempts
        setTimeout(() => {
            fn(fn, data, url, resolve, reject, error, leftAttempts)
        }, 1500)
    }
}
export function postDataWithRetry(url, data) {
    const leftAttempts = 3
    return postData(url, data, leftAttempts)
}
export function postData(url, data, leftAttempts) {
    return new Promise((resolve, reject) => {
        api.post(provideURL(url), data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                repeatRequest(
                    repeatRequest,
                    data,
                    url,
                    resolve,
                    reject,
                    error,
                    leftAttempts
                )
            })
    })
}
export function getData(url, leftAttempts) {
    return new Promise((resolve, reject) => {
        api.get(provideURL(url))
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                if (
                    error &&
                    error.message &&
                    error.message.includes('timeout')
                ) {
                    repeatRequest(
                        repeatRequest,
                        '',
                        url,
                        resolve,
                        reject,
                        error,
                        leftAttempts
                    )
                } else {
                    repeatRequest(
                        repeatRequest,
                        '',
                        url,
                        resolve,
                        reject,
                        error,
                        0
                    )
                }
            })
    })
}
export function getDataWidthRetry(url) {
    const leftAttempts = 3
    return getData(url, leftAttempts)
}
function errorNotif(msg) {
    Vue.notify({
        group: 'error',
        title: i18n.t('TOAST_ERROR_TITLE'),
        duration: 4000,
        text: msg
    })
}
export function handleError(error, errors, section) {
    if (error) {
        console.log(error)
        if (error.response) {
            getErrorMessage(error)
            const causes =
                error.response.data && error.response.data.error.cause
                    ? Object.keys(error.response.data.error.cause)
                    : []
            if (causes.length > 0 && errors) {
                errors.errors = causes.map(cause => {
                    return {
                        name: cause,
                        message: error.response.data.error.cause[cause],
                        section: section
                    }
                })
            }
        } else {
            if (error.message && error.message.includes('timeout')) {
                errorNotif(i18n.t('TOAST_DOWNLOADING_DATA_FAILED'))
            } else if (error.message == 'Network Error') {
                errorNotif(i18n.t('PROBLEM_WITH_INET_OCCURRED'))
            } else {
                Analytics.unknownError777(error)
            }
        }
    }
}
function getErrorMessage(error) {
    const { data } = error.response
    if (!data || !data.error) {
        return errorNotif()
    }
    if (data.error.msg) {
        return errorNotif(data.error.msg)
    }
    if (data.error.cause) {
        const causes = Object.keys(data.error.cause).map(
            key => data.error.cause[key]
        )
        if (causes.length == 1) {
            return errorNotif(causes[0])
        } else {
            return errorNotif()
        }
    } else {
        return errorNotif()
    }
}
export function setHeaders(vue, customJwt) {
    if (!vue.$store.state.user.roles && !customJwt) {
        return
    }
    const jwt = customJwt ? customJwt : vue.$store.state.user.roles[0].jwt

    vue.$api.defaults.headers.common['Authorization'] = `Bearer ${jwt}`
    vue.$assets.defaults.headers.common['Authorization'] = `Bearer ${jwt}`
}
export function resetHeaders(vue) {
    vue.$assets.defaults.headers.common['Authorization'] = ``
    vue.$api.defaults.headers.common['Authorization'] = ``
}
